function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import { useFormContext } from 'react-hook-form';
import React from 'react';
import { useTranslate } from 'shared/helper/translate';
import { parseValidators } from '../util';
import FormRow from './FormRow';
var TextArea = function TextArea(_ref) {
  var description = _ref.description,
    label = _ref.label,
    name = _ref.name,
    messages = _ref.messages,
    validators = _ref.validators,
    required = _ref.required,
    placeholder = _ref.placeholder,
    _ref$styles = _ref.styles,
    styles = _ref$styles === void 0 ? {} : _ref$styles;
  var _useTranslate = useTranslate(),
    t = _useTranslate.t;
  var _useFormContext = useFormContext(),
    register = _useFormContext.register;
  return /*#__PURE__*/React.createElement(FormRow, {
    messages: messages,
    description: description,
    label: label,
    name: name,
    required: typeof required !== 'undefined' ? required : !!validators,
    styles: styles
  }, /*#__PURE__*/React.createElement("textarea", _extends({
    className: styles.controlClass ? styles.controlClass : 'form-control',
    name: name,
    placeholder: t(placeholder || '')
    // eslint-disable-next-line react/jsx-props-no-spreading
  }, register(name, parseValidators({
    validators: validators,
    messages: messages
  })))));
};
export default TextArea;